// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__hWF+6","gridSystem":"styles_gridSystem__mxem9","activityBox":"styles_activityBox__akHty","tableBox":"styles_tableBox__7SUjB"};